export const PERMISSIONS = {
  BULK_CREATION_ACTIONS: 'bulk_creation_actions',
  // Admin-only: signs or clears every policy for an employee in one go.
  BULK_MANAGE_POLICY_SIGNATURES: 'bulk_manage_policy_signatures',
  // Admin-only: imports a CanIPhish campaign into a tenant from the backoffice.
  IMPORT_PHISHING_CAMPAIGNS: 'import_phishing_campaigns',
  LOAD_DICTIONARIES: 'load_dictionaries',
  MANAGE_ALL_USERS: 'manage_all_users',
  MANAGE_API_KEYS: 'manage_api_keys',
  MANAGE_APPSEC: 'manage_appsec',
  MANAGE_COMPLIANCE: 'manage_compliance',
  MANAGE_CONNECTORS: 'manage_connectors',
  MANAGE_EDR: 'manage_edr',
  MANAGE_INFRASTRUCTURE: 'manage_infrastructure',
  MANAGE_CONSULTANTS: 'manage_consultants',
  MANAGE_CASES: 'manage_cases',
  MANAGE_CLOUD_SECURITY: 'manage_cloud_security',
  MANAGE_EASM: 'manage_easm',
  MANAGE_MDM: 'manage_mdm',
  MANAGE_TENANTS: 'manage_tenants',
  MANAGE_USERS: 'manage_users',
  SIGN_POLICIES: 'sign_policies',
  VIEW_ALL_OWN_TENANTS: 'view_all_own_tenants',
  VIEW_ALL_TENANTS: 'view_all_tenants',
  VIEW_ASSETS: 'view_assets',
  VIEW_SUPPLIERS: 'view_suppliers',
  VIEW_ASSET_MANAGEMENT: 'view_asset_management',
  VIEW_AUTOMATED_PENTEST: 'view_automated_pentest',
  VIEW_BACKOFFICE: 'view_backoffice',
  VIEW_BILLING: 'view_billing',
  VIEW_CODE_SCANNER: 'view_code_scanner',
  VIEW_COMPLIANCE: 'view_compliance',
  VIEW_CONNECTORS: 'view_connectors',
  VIEW_EASM: 'view_easm',
  VIEW_EDR_SIEM: 'view_edr_siem',
  VIEW_EMPLOYEE_DASHBOARD: 'view_employee_dashboard',
  VIEW_EMPLOYEES_TRAINING: 'view_employees_training',
  VIEW_HOME: 'view_home',
  VIEW_INFRASTRUCTURE: 'view_infrastructure',
  VIEW_PASSWORD_MANAGEMENT: 'view_password_management',
  VIEW_PEOPLE: 'view_people',
  VIEW_PHISHING_EXERCISES: 'view_phishing_exercises',
  VIEW_REPORTS: 'view_reports',
  VIEW_TASKS: 'view_tasks',
  VIEW_TENANTS: 'view_tenants',
  VIEW_TRUST_CENTER: 'view_trust_center',
  VIEW_APPSEC: 'view_appsec',
  VIEW_DOCUMENTS: 'view_documents',
  // Narrower than VIEW_DOCUMENTS, which also covers drafts, comments and compliance documents.
  VIEW_APPROVED_TEXT_DOCUMENTS: 'view_approved_text_documents',
  VIEW_OPEN_SEARCH: 'view_open_search',
  VIEW_CLOUD_SECURITY: 'view_cloud_security',
  VIEW_EMPLOYEES_CENTER: 'view_employees_center',
  VIEW_CRISIS_MANAGER: 'view_crisis_manager',
  VIEW_IDENTITIES: 'view_identities',
  VIEW_MDM: 'view_mdm',
  VIEW_CHAT_LOGS: 'view_chat_logs',
  // Narrower than VIEW_SUPPLIERS, which also unlocks the Suppliers Dashboard.
  VIEW_SUPPLIER_QUESTIONNAIRES: 'view_supplier_questionnaires',
  MANAGE_SUPPLIER_QUESTIONNAIRES: 'manage_supplier_questionnaires',
} as const
